// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eT__","icon":"styles_icon__-ZW8D"};